export async function setText2Clipboard(text: string): Promise<boolean> {
  try {
    await window.navigator.clipboard.writeText(text);
    return true;
  } catch ( e ) {
    return false;
  }
}
